<template>
  <ContactPage />
</template>

<script>
import AbstractPage from 'chimera/all/components/page/AbstractPage'
import ContactPage from 'chimera/all/components/page/ContactPage.vue'

export default {
  components: {
    ContactPage,
  },

  extends: AbstractPage,

  layout: 'content',

  /**
   * @returns {object}
   */
  data() {
    return {
      headTitle: 'Ponte en contacto con',
      headDescription:
        'Es posible ponerse en contacto con nuestra oficina y recibir mas información. Solamente tiene que completar el formulario y nos pondremos en contacto con usted tan pronto como nos sea posible.',
      path: '/contacto',
    }
  },
}
</script>
